export const VIEW_ROLES = ['OWNER', 'SUPPORT_ADMIN', 'SUPPORT', 'FW_MANAGER', 'FW_ENGINEER'];
export const UPLOAD_ROLES = ['OWNER', 'FW_ENGINEER'];
export const RELEASE_ROLES = ['OWNER', 'FW_MANAGER'];
export const REMOVE_ROLES = ['OWNER', 'FW_MANAGER', 'FW_ENGINEER'];
export const DEVICE_WRITE_ROLES = ['OWNER', 'FW_MANAGER', 'FW_ENGINEER'];

export const INITIAL_UPLOAD_FORM = {
  deviceModel: '',
  hardwareVersion: '',
  firmwareVersion: '',
  requiredFirmwareVersion: '',
};

export const INITIAL_BATCH_FORM = {
  region: 'EU Central 1',
  deviceModel: 'WallStation',
  firmwareId: 'fw-ws-638-production',
  target: 'All eligible devices',
  onlineOnly: true,
  ticket: '',
  firstWave: '50',
  secondWave: '75',
  thirdWave: '115',
};
